<template>
  <div>
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">Page Help</div>
        <q-space></q-space>
        <!-- <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="saveAndAddNew"
        >
          Save & Add New
        </q-btn> -->
        <q-btn
          :loading="isLoading"
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="save(true)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <div class="row q col-gutter-x-lg q-col-gutter-y-md">
          <div class="col-12">
            <q-card flat>
              <q-card-section>
                <div class="row q-mb-sm items-center">
                  <div class="col-6">
                    <div class="row items-center q-col-gutter-x-md">
                      <div class="col-3">
                        <div class="title q-my-none">Info</div>
                      </div>
                    </div>
                  </div>
                </div>
                <q-form ref="form">
                  <div class="row q-col-gutter-y-sm q-mb-lg q-col-gutter-x-lg">
                    <div class="col-12">
                      <q-input
                        :label="`Path (The Path is the last part of the URL, For example, the path for this page would be /pageHelp/${formData.id})`"
                        v-model="formData.path"
                        :rules="[(v) => !!v || 'Field is Required']"
                        :hint="``"
                      >
                      </q-input>
                    </div>
                    <div class="col-12">
                      <q-editor
                        style="height: 300px"
                        v-model="formData.text"
                        :dense="$q.screen.lt.md"
                        :toolbar="[
                          [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              list: 'only-icons',
                              options: ['left', 'center', 'right', 'justify'],
                            },
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify'],
                            },
                          ],
                          [
                            'bold',
                            'italic',
                            'strike',
                            'underline',
                            'subscript',
                            'superscript',
                          ],
                          ['token', 'hr', 'link', 'custom_btn'],
                          ['print', 'fullscreen'],
                          [
                            {
                              label: $q.lang.editor.formatting,
                              icon: $q.iconSet.editor.formatting,
                              list: 'no-icons',
                              options: [
                                'p',
                                'h1',
                                'h2',
                                'h3',
                                'h4',
                                'h5',
                                'h6',
                                'code',
                              ],
                            },
                            {
                              label: $q.lang.editor.fontSize,
                              icon: $q.iconSet.editor.fontSize,
                              fixedLabel: true,
                              fixedIcon: true,
                              list: 'no-icons',
                              options: [
                                'size-1',
                                'size-2',
                                'size-3',
                                'size-4',
                                'size-5',
                                'size-6',
                                'size-7',
                              ],
                            },
                            {
                              label: $q.lang.editor.defaultFont,
                              icon: $q.iconSet.editor.font,
                              fixedIcon: true,
                              list: 'no-icons',
                              options: [
                                'default_font',
                                'arial',
                                'arial_black',
                                'comic_sans',
                                'courier_new',
                                'impact',
                                'lucida_grande',
                                'times_new_roman',
                                'verdana',
                              ],
                            },
                            'removeFormat',
                          ],
                          [
                            'quote',
                            'unordered',
                            'ordered',
                            'outdent',
                            'indent',
                          ],

                          ['undo', 'redo'],
                          ['viewsource'],
                        ]"
                        :fonts="{
                          arial: 'Arial',
                          arial_black: 'Arial Black',
                          comic_sans: 'Comic Sans MS',
                          courier_new: 'Courier New',
                          impact: 'Impact',
                          lucida_grande: 'Lucida Grande',
                          times_new_roman: 'Times New Roman',
                          verdana: 'Verdana',
                        }"
                      />
                    </div>
                  </div>
                </q-form>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    data: () => ({
      isLoading: false,
      formData: {},
    }),
    computed: {
      ...mapGetters({
        data: "pageHelp/current",
      }),
    },
    watch: {
      data: {
        deep: true,
        handler() {
          this.init();
        },
      },
    },
    mounted() {
      this.$store.dispatch("pageHelp/loadByID", this.$route.params.pageHelp_id);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        }
      },
      async save(isClose = false) {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          let payload = {
            id: this.$route.params.id,
            ...this.formData,
          };
          let result = await this.$store.dispatch("pageHelp/save", payload);
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            if (isClose) {
              this.closeDialog();
            }
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },

      closeDialog() {
        this.$router.push("/pageHelp");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }
  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }
</style>
